export default __webpack_public_path__ + "static/media/banner-sample.69ea7dd8.svg";